<!-- Approved memberships -->
<div class="bg-white p-5">
  <h2 class="text-lg font-bold mb-4 text-dc-navy">
    {{ "BUSINESS_GROUP.TITLE" | translate }}
  </h2>

  <div class="grid md:grid-cols-2 gap-6">
    @for (m of memberships; track m) {
      <div
        class="border border-dc-navy p-5 relative"
        >
        <h2 class="text-dc-navy font-semibold mb-2">{{ m.name }}</h2>
        <!-- chips -->
        <div class="flex gap-2 mb-4">
          <span class="dc-status dc-status-active">
            {{ "BUSINESS_GROUP.LICENSE_ACTIVE" | translate }}
          </span>
          <!-- <span *ngIf="m.actionRequired" class="dc-status-inactive">
          {{ 'BUSINESS_GROUP.ACTION_REQUIRED' | translate : { n: m.actionRequired } }}
        </span> -->
      </div>
      <div class="flex gap-6">
        <!-- left column -->
        <div class="text-dc-navy text-sm">
          <div class="mb-2">
            {{ "BUSINESS_GROUP.NUM" | translate }}
            <div class="font-semibold">{{ m.membershipNumber }}</div>
          </div>
          <div class="mb-2">
            {{ "BUSINESS_GROUP.EXP" | translate }}
            <div class="font-semibold">{{ m.expiryDate }}</div>
          </div>
        </div>
        <!-- right column -->
        <div class="text-dc-navy text-sm">
          <div class="mb-2">
            {{ "BUSINESS_GROUP.LIC" | translate }}
            <div class="font-semibold">{{ m.tradeLicense }}</div>
          </div>
          <div class="mb-2">
            {{ "BUSINESS_GROUP.USERS" | translate }}
            <div class="font-semibold">{{ m.activeUsers }}</div>
          </div>
        </div>
      </div>
      <!-- Actions -->
      <div class="flex items-center gap-4 text-sm mt-7">
        <app-button
          classesName="card-edge-cut-white"
          [label]="'BUTTONS.VIEW_DETAILS' | translate"
          (onBtnClick)="viewGroup(m)"
          />
        </div>
        <!-- corner decoration -->
        <span
        [ngClass]="{
          'border-b-dc-green': m.status === 'active',
          'border-b-dc-orange': m.status === 'action-required'
        }"
          class="absolute w-0 h-0 border-l-[16px] border-b-[16px] border-l-transparent bottom-0 right-0"
        ></span>
      </div>
    }
  </div>
</div>

<!-- Pending approval -->
<div class="bg-white p-5 mt-5">
  <h2 class="text-lg font-bold my-6 text-dc-navy">
    {{ "BUSINESS_GROUP.PENDING" | translate }}
  </h2>

  <div class="grid md:grid-cols-2 gap-6">
    @for (p of pending; track p) {
      <div class="border border-dc-navy p-5 relative">
        <div class="mb-5">
          <h2 class="text-dc-navy font-semibold mb-2">{{ p.name }}</h2>
          <div class="flex gap-6">
            <div class="text-dc-navy text-sm">
              <div class="mb-2">
                {{ "BUSINESS_GROUP.NUM" | translate }}
                <div class="font-semibold">{{ p.membershipNumber }}</div>
              </div>
              <div class="mb-2">
                {{ "BUSINESS_GROUP.USERS" | translate }}
                <div class="font-semibold">{{ p.activeUsers }}</div>
              </div>
            </div>
            <div class="text-dc-navy text-sm">
              <div class="mb-2">
                {{ "BUSINESS_GROUP.LIC" | translate }}
                <div class="font-semibold">{{ p.tradeLicense }}</div>
              </div>
            </div>
          </div>
          <!-- Actions -->
          <!-- <div class="flex items-center gap-4 text-sm mt-7">
          <app-button
            classesName="btn-edge-cut"
            [label]="'BUTTONS.ACCEPT' | translate"
            (onBtnClick)="false"
            />
            <app-button
              classesName="card-edge-cut-white"
              [label]="'BUTTONS.REJECT' | translate"
              (onBtnClick)="false"
              />
            </div> -->
          </div>
          <!-- Bottom navy corner -->
          <span
            class="absolute w-0 h-0 border-l-[16px] border-b-[16px] border-l-transparent border-b-dc-navy bottom-0 right-0"
          ></span>
        </div>
      }
    </div>
  </div>
